export const PUBLIC_SUBCHAT_TYPE = "public";
export const PRIVATE_SUBCHAT_TYPE = "private";
export const ANNOUNCEMENT_SUBCHAT_TYPE = "announcement";
